/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { func, string, bool } from 'prop-types';
import Tooltip from '../../Tooltip';

const Actions = ({
  onDownload,
  icon = 'bi bi-arrow-down-circle-fill',
  disabled = false,
  hidden = false,
  tooltipText = 'Descargar',
  tooltipPlacement = 'top'
}) => {
  if (hidden) return null;

  const iconElement = (
    <i
      className={icon}
      onClick={disabled ? undefined : onDownload}
      role="button"
      tabIndex={disabled ? -1 : 0}
      style={{
        fontSize: '20px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        display: 'inline-block',
        cursor: disabled ? 'not-allowed' : 'pointer'
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.color = '#009092';
          e.target.style.transform = 'translateY(-2px) scale(1.1)';
          e.target.style.filter = 'drop-shadow(0 4px 8px rgba(0, 179, 181, 0.3))';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.target.style.color = '#00B3B5';
          e.target.style.transform = 'translateY(0) scale(1)';
          e.target.style.filter = 'none';
        }
      }}
      onMouseDown={(e) => {
        if (!disabled) {
          e.target.style.transform = 'translateY(0) scale(1.05)';
        }
      }}
      onMouseUp={(e) => {
        if (!disabled) {
          e.target.style.transform = 'translateY(-2px) scale(1.1)';
        }
      }}
    />
  );

  return (
    <>
      {disabled ? (
        <span className='disabled-action'>
          <Tooltip text={tooltipText} disabled={disabled}>
            {iconElement}
          </Tooltip>
        </span>
      ) : (
        <div className="actions-wrapper">
          <Tooltip
            text={tooltipText}
            placement={tooltipPlacement}
            disabled={disabled}
          >
            {iconElement}
          </Tooltip>
        </div>
      )}
    </>
  );
};

Actions.propTypes = {
  onDownload: func.isRequired,
  icon: string,
  disabled: bool,
  hidden: bool,
  tooltipText: string,
  tooltipPlacement: string
};



export default Actions;
